// 半角英数記号
export const validHalfSize = (value: string) => {
  const regExp = new RegExp(/^[A-Za-z0-9-]*$/)
  return regExp.test(value)
}

export const validFullSize = (value: string) => {
  const regExp = new RegExp(/^[^\x20-\x7e]*$/)
  return regExp.test(value)
}

export const validNumber = (value: string) => {
  const regExp = new RegExp(/^[0-9]*$/)
  return regExp.test(value)
}

const validMailAddress = (value: string) => {
  console.log(value.length)
  if (value.length === 0) {
    return true
  } else {
    const regExp = new RegExp(
      /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/
    )
    console.log(regExp.test(value))
    return regExp.test(value)
  }
}

const validPhoneNumber = (value: string) => {
  const regExp = new RegExp(/^(0{1}\d{1,4}-{0,1}\d{1,4}-{0,1}\d{4})$/)
  return regExp.test(value)
}

const validPhoneNumberSpace = (value: string) => {
  value = value.replace(/[*\-.*]/gi, '')
  const regExp = new RegExp(/^([0-9-])*$/)
  return regExp.test(value)
}

const validHarfStrAndSymbol = (value: string) => {
  const regExp = new RegExp(/^[a-zA-Z0-9!-/:-@¥[-`{-~]{8,16}$/)
  return regExp.test(value)
}

const isFullStrKana = (s: string) => {
  /* eslint no-irregular-whitespace: ["error", {"skipRegExps": true}] */
  return !!s.match(/^[ァ-ヶー　]*$/)
}

const isZenginChars = (s: string) => {
  /* eslint no-irregular-whitespace: ["error", {"skipRegExps": true}] */
  return !!s.match(/^[（）「」・ァ-ヶー ]*$/)
}

const isEstablishmentNumber = (value: string) => {
  const regExp = new RegExp(/^T\d{13}$/)
  return regExp.test(value)
}

const isPast = (value: Date | string) => {
  if (value == '') return false
  const today = new Date()
  today.setHours(0, 0, 0)
  if (today.getTime() >= (value as Date).getTime()) {
    return true
  } else {
    return false
  }
}

export const validZip = (
  value: string,
  errorList: { [key: string]: string[] },
  key: string
) => {
  const isNumber = validNumber(value)
  if (isNumber) {
    delete errorList[key]
  } else {
    errorList[key] = []
    errorList[key].push('半角数字で入力してください。')
  }
}

export const validUpperLimitNumeric = (
  value: string,
  errorList: { [key: string]: string[] | string },
  key: string
) => {
  const isNumber = validNumber(value)

  let isMinLengthAllow = true

  if (String(value).length < 10) {
    isMinLengthAllow = false
  }

  if (isNumber && isMinLengthAllow) {
    delete errorList[key]
  } else {
    if (!isNumber) {
      errorList[key] = '半角数字で入力してください。'
    } else {
      errorList[key] = '事業所番号は10桁で入力してください。'
    }
  }
}

export const validUpperLimitPhoneNumber = (
  value: string,
  errorList: { [key: string]: string[] | string },
  key: string
) => {
  const isPhoneNumber = validPhoneNumberSpace(value)
  if (isPhoneNumber) {
    delete errorList[key]
  } else {
    errorList[key] = '電話番号の形式で入力してください。'
  }
}

export const validOfficeArrayNumeric = (
  value: string,
  errorList: any,
  key: string,
  index: number
) => {
  const isNumber = validNumber(value)

  let isMinLengthAllow = true

  if (String(value).length < 10) {
    isMinLengthAllow = false
  }

  if (isNumber && isMinLengthAllow) {
    if (errorList[key]) {
      delete errorList[key][index]
    }

    if (errorList[key] && Object.keys(errorList[key]).length === 0) {
      delete errorList[key]
    }
  } else {
    if (!errorList[key]) {
      errorList[key] = {}
    }

    if (!isNumber) {
      errorList[key][index] = '半角数字で入力してください。'
    } else {
      errorList[key][index] = '事業所番号は10桁で入力してください。'
    }
  }
}

export const validOfficeArrayPhoneNumber = (
  value: string,
  errorList: any,
  key: string,
  index: number
) => {
  const isPhoneNumber = validPhoneNumberSpace(value)
  if (isPhoneNumber) {
    if (errorList[key]) {
      delete errorList[key][index]
    }

    if (errorList[key] && Object.keys(errorList[key]).length === 0) {
      delete errorList[key]
    }
  } else {
    if (!errorList[key]) {
      errorList[key] = {}
    }
    errorList[key][index] = '電話番号の形式で入力してください。'
  }
}

export const ValidFullStr = (
  value: string,
  errorList: { [key: string]: string[] },
  key: string
) => {
  const isFullStr = validFullSize(value)
  if (isFullStr) {
    delete errorList[key]
  } else {
    errorList[key] = []
    errorList[key].push('全角で入力してください。')
  }
}

export const validStr = (
  value: string,
  errorList: { [key: string]: string[] },
  key: string
) => {
  const isNumber = validNumber(value)
  if (isNumber) {
    errorList[key] = []
    errorList[key].push('文字を入力してください。')
  } else {
    delete errorList[key]
  }
}

export const validFullStrKana = (
  value: string,
  errorList: { [key: string]: string[] },
  key: string
) => {
  if (value === null || value === undefined) return
  const isFullStr = isFullStrKana(value)
  if (isFullStr) {
    delete errorList[key]
  } else {
    errorList[key] = []
    errorList[key].push('全角カナで入力してください。')
  }
}

export const validHalf = (
  value: string,
  errorList: { [key: string]: string[] },
  key: string
) => {
  const isHalfSize = validHalfSize(value)
  if (isHalfSize) {
    delete errorList[key]
  } else {
    errorList[key] = []
    errorList[key].push('ハイフンを含む半角で入力してください。')
  }
}

export const validHalfNumber = (
  value: string,
  errorList: { [key: string]: string[] },
  key: string
) => {
  const isHalfNumber = validNumber(value)
  if (isHalfNumber) {
    delete errorList[key]
  } else {
    errorList[key] = []
    errorList[key].push('半角数字で入力してください。')
  }
}

export const validMail = (
  value: string,
  errorList: { [key: string]: string[] },
  key: string
) => {
  const isMailAddress = validMailAddress(value)
  if (isMailAddress) {
    delete errorList[key]
  } else {
    errorList[key] = []
    errorList[key].push('メールアドレスの形式で入力してください。')
  }
}

export const validPhone = (
  value: string,
  errorList: { [key: string]: string[] },
  key: string
) => {
  const number = value.replace(/[━.*‐.*―.*－.*\-.*ー.*]/gi, '')
  const isPhoneNumber = validPhoneNumber(number)
  console.log(isPhoneNumber)
  if (value.length === 0) {
    delete errorList[key]
  } else {
    if (isPhoneNumber) {
      delete errorList[key]
    } else {
      errorList[key] = []
      errorList[key].push('電話番号の形式で入力してください。')
    }
  }
}

export const validParentsPassword = (
  value: string,
  errorList: { [key: string]: string[] },
  key: string
) => {
  const validPattern = /^[a-zA-Z0-9!-/:-@[-`{-~]+$/
  errorList[key] = []
  if (value.length < 8 && value.length > 0) {
    errorList[key] = []
    errorList[key].push('パスワードは8文字以上で入力してください。')
  }
  if (value.length > 0 && !validPattern.test(value)) {
    errorList[key].push('パスワードは半角英数字および記号のみ使用できます。')
  }
  if (errorList[key].length === 0) {
    delete errorList[key]
  }
}

export const validParentsLinePassword = (
  value: string,
  errorList: { [key: string]: string[] },
  key: string
) => {
  if (value.length < 8 && value.length !== 0) {
    errorList[key] = []
    errorList[key].push('パスワードは8文字以上で入力してください。')
  } else if (value.length === 0) {
    delete errorList[key]
  } else {
    delete errorList[key]
  }
}

export const validZipPassword = (
  value: string,
  errorList: { [key: string]: string[] },
  key: string
) => {
  const isHalfStr = validHarfStrAndSymbol(value)
  if (isHalfStr) {
    delete errorList[key]
  } else {
    errorList[key] = []
    errorList[key].push('8文字以上16文字以下の半角数字で入力してください。')
  }
}

export const validStaffPhone = (
  value: string,
  errorList: { [key: string]: string[] },
  key: string
) => {
  value = String(value)
  const isPhoneNumber = validPhoneNumberSpace(String(value))
  console.log(isPhoneNumber)
  if (value.length === 0) {
    delete errorList[key]
  } else {
    if (isPhoneNumber) {
      delete errorList[key]
    } else {
      errorList[key] = []
      errorList[key].push('電話番号の形式で入力してください。')
    }
  }
}

export const validHalfString = (
  value: string,
  errorList: { [key: string]: string[] },
  key: string
) => {
  const isHalfSize = validHalfSize(value)
  if (isHalfSize) {
    delete errorList[key]
  } else {
    errorList[key] = []
    errorList[key].push('半角英数字で入力してください。')
  }
}

export const displayError = (
  errorList: { [key: string]: string[] },
  key: string
) => {
  return errorList[key]
}

export const displayArrayError = (
  errorList: { [key: string]: any },
  key: string,
  index: number
) => {
  if (errorList[key]) {
    return errorList[key][index]
  }
}

export const ValidEstablishmentNumber = (
  value: string,
  errorList: { [key: string]: string[] },
  key: string
) => {
  const isEmpty = value.length === 0
  const isValid = isEstablishmentNumber(value)
  if (isEmpty) {
    delete errorList[key]
  } else if (isValid) {
    delete errorList[key]
  } else {
    errorList[key] = []
    errorList[key].push('T＋13桁の数字で入力してください。')
  }
}

export const ValidDateIsPast = (
  value: Date,
  errorList: { [key: string]: string[] },
  key: string
) => {
  const isValid = isPast(value)
  if (isValid) {
    errorList[key] = []
    errorList[key].push('今日より未来の日付を選択してください。')
  } else {
    delete errorList[key]
  }
}

export const validFullStrKanaMaxLength = (
  value: string,
  errorList: any,
  key: string,
  label: string,
  maxLength: number
) => {
  if (value === null || value === undefined) return
  const isFullStr = isZenginChars(value)

  let isMaxLengthAllow = true
  if (value.length > maxLength) {
    isMaxLengthAllow = false
  }

  if (isFullStr && isMaxLengthAllow) {
    if (errorList[key]) {
      delete errorList[key]
    }
  } else {
    errorList[key] = []

    if (!isFullStr) {
      errorList[key].push('全角カナで入力してください。')
    } else if (!errorList[key].length) {
      errorList[key].push(`${label}は${maxLength}文字以内で入力してください。`)
    }
  }
}

export const validNumericLength = (
  value: string,
  errorList: any,
  key: string,
  label: string,
  length: number
) => {
  const isNumber = validNumber(value)

  let isLengthAllow = true

  if (String(value).length !== length) {
    isLengthAllow = false
  }

  if (isNumber && isLengthAllow) {
    if (errorList[key]) {
      delete errorList[key]
    }
  } else {
    errorList[key] = []

    if (!isNumber) {
      errorList[key].push('半角数字で入力してください。')
    } else if (!errorList[key].length) {
      errorList[key].push(`${label}は${length}桁の数字で入力してください。`)
    }
  }
}

export const validCustomerNumber = (
  value: string,
  errorList: { [key: string]: string[] },
  key: string
) => {
  if (value === '') {
    return
  }

  const isNumber = validNumber(value)

  const minLength = 20
  let isMinLengthAllow = true

  if (String(value).length > minLength) {
    isMinLengthAllow = false
  }

  if (isNumber && isMinLengthAllow) {
    if (errorList[key]) {
      delete errorList[key]
    }
  } else {
    errorList[key] = []

    if (!isNumber) {
      errorList[key].push('半角数字で入力してください。')
    } else if (!errorList[key].length) {
      errorList[key].push(`顧客番号は20桁以内の数字で入力してください。`)
    }
  }
}

export const ValidWithdrawalDay = (
  value: number,
  errorList: { [key: string]: string[] },
  key: string
) => {
  let isValid = true

  if (!value) {
    isValid = false
  } else if (value < 1 || value > 31) {
    isValid = false
  }

  if (isValid) {
    delete errorList[key]
  } else {
    errorList[key] = []
    errorList[key].push('有効な日付を入力してください。')
  }
}
